import React from 'react';
import { useTranslate, Title } from 'react-admin';
import AccountFormWizard from './AccountFormWizard';
import { createEmptyAccountFormValues } from '../constants';

export const AccountCreate: React.FC = () => {
  const translate = useTranslate();
  return (
    <>
      <Title title={translate('resources.accounts.account.title')} />
      <AccountFormWizard mode="create" initialValues={createEmptyAccountFormValues()} />
    </>
  );
};

export default AccountCreate;
